import { useEffect } from 'react';

function useElementHeight<T extends HTMLElement>(
  ref: React.RefObject<T>,
  cssVarName: string
): void {
  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return () => {};
    }

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) {
        return;
      }

      document.documentElement.style.setProperty(
        cssVarName,
        `${entry.contentRect.height}px`
      );
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [ref, cssVarName]);
}

export default useElementHeight;
